import { createStyles, makeStyles } from '@hawkins/styles';
export function badgeStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            alignItems: 'center',
            backgroundColor: hawkinsVariables.colors.transparent,
            borderColor: hawkins.lifecycle.backgroundColorProduction,
            borderRadius: 12,
            borderStyle: 'solid',
            borderWidth: 1,
            color: hawkins.textColor.textColorRegular,
            display: 'inline-grid',
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontSize: hawkinsVariables.fontSizes.fontSize2,
            fontWeight: 600,
            gridTemplateColumns: 'max-content 1fr',
            height: hawkinsVariables.sizings.size2,
            justifyItems: 'center',
            paddingLeft: hawkinsVariables.spacings.space1,
            paddingRight: hawkinsVariables.spacings.space1,
        },
        /* Class name to apply when the component is disabled */
        disabled: {
            opacity: 0.4,
        },
        /* Class name to apply when the component has an `endAdornment` */
        withEndAdornment: {
            gridTemplateColumns: 'max-content 1fr max-content',
        },
        /** Class name to apply to the component's label */
        label: {
            gridColumn: 2,
            paddingLeft: hawkinsVariables.spacings.space1,
            paddingRight: 1,
            width: '100%',
        },
        /** Class name to apply to the component's label when there is an `endAdornment` */
        labelWithEndAdornment: {
            paddingRight: hawkinsVariables.spacings.space0,
            width: '100%',
        },
        /** Class name to apply to the component's circle */
        circle: {
            backgroundColor: hawkins.lifecycle.backgroundColorProduction,
            borderRadius: '50%',
            gridColumn: 1,
            height: 8,
            width: 8,
        },
        /** Class name to apply to the components `endAdornment` */
        endAdornment: {
            gridColumn: 3,
        },
        /** Class name to apply to the component when variant is `high-density` */
        highDensity: {
            borderColor: hawkinsVariables.colors.transparent,
            paddingLeft: 0,
            paddingRight: 0,
        },
        /** Class name to apply to the component's label when the variant is `high-density` */
        labelHighDensity: {},
    });
}
export var useBadgeStyles = makeStyles(badgeStyles, { name: 'Hawkins-Badge' });
